import { all } from 'redux-saga/effects';

import payrollWatcher from './payroll-setting-saga';

export default function* rootSaga(action) {
	console.log('rootSaga');
	yield all([payrollWatcher(action)]);
}
